import { render } from "./WoTThingDescriptionsShowView.vue?vue&type=template&id=e9bd3e00"
import script from "./WoTThingDescriptionsShowView.vue?vue&type=script&lang=js"
export * from "./WoTThingDescriptionsShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__